import { useCallback, useEffect } from 'react';
import { useQueries, useQuery } from '@tanstack/react-query';
import createQueryRequest from 'services/createQueryRequest';
import useAPI from 'services/useAPI';
import _ from 'lodash';


export const treeKeys = {
  trees: () => ['trees'],
  tree: (treeId) => ['tree', treeId]
};


export const createTreeQuery = (api, treeId, options) => ({
  queryKey: treeKeys.tree(treeId),
  queryFn: createQueryRequest(api.core.getTreeFromNode),
  enabled: treeId != null,
  refetchOnWindowFocus: false,
  ...options
});

const useTreeQuery = (treeId, options) => {
  const api = useAPI();
  return useQuery(createTreeQuery(api, treeId, options));
};

export const useMultiTreeQuery = (treeIds, options) => {
  const api = useAPI();
  return useQueries({ queries: _.map(treeIds, treeId => createTreeQuery(api, treeId, options)) });
};

// export const createTreeItemsQuery = (api, treeId, options) => ({
//   queryKey: ['treeItems', treeId],
//   queryFn: createQueryRequest(api.assets.getTreeItems),
//   enabled: treeId != null,
//   refetchOnWindowFocus: false,
//   ...options
// });

// export const useTreeItemsQuery = (treeId, options) => {
//   const api = useAPI();
//   return useQuery(createTreeItemsQuery(api, treeId, options));
// };

// export const useMultiTreeItemsQuery = (treeIds, options) => {
//   const api = useAPI();
//   return useQueries({ queries: _.map(treeIds, treeId => createTreeItemsQuery(api, treeId, options)) });
// };


export const useTreeRoots = ({ onError } = { onError: undefined }) => {
  const api = useAPI();

  const query = useQuery(treeKeys.trees(),
    createQueryRequest(api.core.getTrees),
    {
      refetchOnWindowFocus: false
    });

  const treeRoots = query.data ?? [];
  const isLoading = query.isLoading;
  useEffect(() => {
    if (query.isError) {
      onError?.('failed to fetch roots');
    }
  }, [onError, query.isError]);

  const refreshList = useCallback(() => {
    query.refetch({ throwOnError: true });
  }, [query]);

  return [treeRoots, isLoading, refreshList, query.isError];
};

export default useTreeQuery;
